import React from "react";
import PlayerList from "../features/PlayerList";
import PlaybookManager from "../features/PlaybookManager";
import EngagementTracker from "../features/EngagementTracker";

const Dashboard = () => {
  return (
    <main className="main-content">
      <div className="container content-padding">
        {/* Welcome Section */}
        <div className="dashboard-header">
          <h2 className="dashboard-title">Coach Dashboard</h2>
          <p className="dashboard-subtitle">
            Manage your players, assign playbooks, and track engagement
          </p>
        </div>

        {/* Dashboard Sections */}
        <div className="sections-container">
          {/* Players Section */}
          <section id="players">
            <PlayerList />
          </section>

          {/* Playbooks Section */}
          <section id="playbooks">
            <PlaybookManager />
          </section>

          {/* Engagement Section */}
          <section id="engagement">
            <EngagementTracker />
          </section>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
